import { parsePadding } from "./../../vrender";

import { isArray, isNumber, isString } from "@visactor/vutils";

export function getQuadProps(paddingOrigin) {
    var _a, _b, _c, _d;
    if (isNumber(paddingOrigin) || isString(paddingOrigin) || isArray(paddingOrigin)) {
        let padding = parsePadding(paddingOrigin);
        return "number" == typeof padding || "string" == typeof padding ? padding = [ padding, padding, padding, padding ] : Array.isArray(padding) && (padding = padding.slice(0)), 
        padding;
    }
    return paddingOrigin && (isFinite(paddingOrigin.bottom) || isFinite(paddingOrigin.left) || isFinite(paddingOrigin.right) || isFinite(paddingOrigin.top)) ? [ null !== (_a = paddingOrigin.top) && void 0 !== _a ? _a : 0, null !== (_b = paddingOrigin.right) && void 0 !== _b ? _b : 0, null !== (_c = paddingOrigin.bottom) && void 0 !== _c ? _c : 0, null !== (_d = paddingOrigin.left) && void 0 !== _d ? _d : 0 ] : [ 0, 0, 0, 0 ];
}
//# sourceMappingURL=padding.js.map
